import PlaylistView from "./PlaylistView";

export default PlaylistView;
